import React from "react";
import ImageUploadFlow from "../ImageUploadFlow";

interface AssetImageUploadModalProps {
  asset: { id?: string; name?: string; imageUrl?: string | null; __proposedAsset?: boolean; [key: string]: unknown };
  onClose?: (result?: { success: boolean; imageUrl?: string }) => void;
}

const AssetImageUploadModal: React.FC<AssetImageUploadModalProps> = ({ asset, onClose }) => {
  const uploadTarget = asset?.__proposedAsset ? "generic" : "asset";
  return <ImageUploadFlow asset={asset} onClose={onClose} uploadTarget={uploadTarget} />;
};

export default AssetImageUploadModal;
